'use es6';

import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import pick from 'hs-lodash/pick';

var parse = function parse(query) {
  if (query == null || query.trim() === '') {
    return {};
  }

  return query.split('&').reduce(function (result, current) {
    var _current$split = current.split('='),
        _current$split2 = _slicedToArray(_current$split, 2),
        key = _current$split2[0],
        value = _current$split2[1];

    var keyName = key;
    var decodedValue = decodeURIComponent(value); // parse query strings in the form foo[] for arrays. This is only for compatibility and
    // repeating keys should be favored.

    if (keyName.length > 2 && keyName.lastIndexOf('[]') === keyName.length - 2) {
      keyName = keyName.substring(0, keyName.length - 2);
    }

    var existing = result[keyName];

    if (existing !== undefined) {
      if (Array.isArray(existing)) {
        existing.push(decodedValue);
      } else {
        result[keyName] = [existing, decodedValue];
      }
    } else {
      result[keyName] = decodedValue;
    }

    return result;
  }, {});
};

function ensureFn(fn) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

  if (typeof fn !== 'function') {
    return fallback;
  }

  return fn;
}

function extractProperty() {
  var objs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var property = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var match = objs.find(function (obj) {
    return obj && typeof obj[property] !== 'undefined';
  });
  return match ? match[property] : defaultValue;
}

export function isExpired(updatedAt, maxAge) {
  var timeInStoreMs = Math.abs(Date.now() - updatedAt);
  return timeInStoreMs > maxAge;
}
export function getCacheKey(treatmentKey, paramKey) {
  return treatmentKey + "-" + paramKey;
}
export function getCacheKeys(_ref) {
  var schema = _ref.schema;
  return Object.keys(schema).reduce(function (acc, treatmentKey) {
    var _schema$treatmentKey = schema[treatmentKey],
        parameters = _schema$treatmentKey.parameters,
        _schema$treatmentKey$ = _schema$treatmentKey.maxAge,
        maxAge = _schema$treatmentKey$ === void 0 ? undefined : _schema$treatmentKey$;
    Object.keys(parameters).forEach(function (paramKey) {
      acc.push({
        key: getCacheKey(treatmentKey, paramKey),
        maxAge: maxAge
      });
    });
    return acc;
  }, []);
}
export function getOverridesFromSearch(_ref2) {
  var cacheKeys = _ref2.cacheKeys,
      _ref2$search = _ref2.search,
      search = _ref2$search === void 0 ? '' : _ref2$search;
  var overrideKeys = cacheKeys.map(function (_ref3) {
    var key = _ref3.key;
    return key;
  }); // remove ? from start of search query

  var cleaned = search && search.length && search[0] === '?' ? search.substr(1, search.length) : '';
  return pick(parse(cleaned), overrideKeys);
}
export function getOverridesFromCache(_ref4) {
  var cacheKeys = _ref4.cacheKeys,
      asyncStore = _ref4.asyncStore,
      onError = _ref4.onError;
  var asyncStoreValues = [];
  var overrides = {};

  if (typeof asyncStore === 'function') {
    cacheKeys.forEach(function () {
      var cacheKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var asyncValue = asyncStore('get', cacheKey.key).then(function () {
        var cacheEntry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        var _ref5 = cacheEntry || {},
            _ref5$updatedAt = _ref5.updatedAt,
            updatedAt = _ref5$updatedAt === void 0 ? 0 : _ref5$updatedAt,
            _ref5$value = _ref5.value,
            value = _ref5$value === void 0 ? '' : _ref5$value;

        if (value && updatedAt) {
          var key = extractProperty([cacheKey, cacheEntry], 'key', '');
          var maxAge = extractProperty([cacheKey, cacheEntry], 'maxAge', 0);

          if (!isExpired(updatedAt, maxAge)) {
            overrides[key] = value;
          }
        }
      }).catch(ensureFn(onError));
      asyncStoreValues.push(asyncValue);
    });
  }

  return Promise.all(asyncStoreValues).then(function () {
    return overrides;
  });
}
export function saveOverridesToCache(_ref6) {
  var schema = _ref6.schema,
      treatments = _ref6.treatments,
      asyncStore = _ref6.asyncStore,
      onError = _ref6.onError;
  var asyncStoreValues = [];

  if (typeof asyncStore === 'function') {
    Object.keys(treatments).forEach(function (treatmentKey) {
      var treatment = treatments[treatmentKey];
      Object.keys(treatment.parameters).forEach(function (paramKey) {
        var cacheKey = getCacheKey(treatmentKey, paramKey);
        asyncStore('get', cacheKey).then(function () {
          var cacheEntry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          var _ref7 = cacheEntry || {},
              _ref7$updatedAt = _ref7.updatedAt,
              updatedAt = _ref7$updatedAt === void 0 ? 0 : _ref7$updatedAt;

          var maxAge = extractProperty([schema[treatmentKey], treatment, cacheEntry], 'maxAge', 0);
          var value = treatment['parameters'][paramKey];

          if (maxAge > 0 && isExpired(updatedAt, maxAge)) {
            asyncStoreValues.push(asyncStore('set', cacheKey, {
              key: cacheKey,
              updatedAt: Date.now(),
              maxAge: maxAge,
              value: value
            }).catch(ensureFn(onError)));
          } else if (!!updatedAt && maxAge === 0) {
            asyncStoreValues.push(asyncStore('delete', cacheKey).catch(ensureFn(onError)));
          }
        }).catch(ensureFn(onError));
      });
    });
  }

  return Promise.all(asyncStoreValues);
}